import React, { useState } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Button, Icon } from '@fourthwall/components';
import { ArrowShortDownIcon, DragIcon, PencilIcon, TrashIcon } from '@fourthwall/icons';
import * as S from './EditableSettingsItem.styled';
import { InlineSettingEditor } from './InlineSettingEditor';
const SettingContent = ({ setting }) => {
    switch (setting.type) {
        case 'header':
            return (React.createElement(S.SettingInfo, null,
                React.createElement(S.SettingType, null, setting.type),
                React.createElement(S.SettingName, null, setting.content)));
        default:
            return (React.createElement(S.SettingInfo, null,
                React.createElement(S.SettingType, null, setting.type),
                React.createElement(S.SettingName, null, setting.label),
                React.createElement(S.SettingId, null,
                    "key: ",
                    React.createElement("b", null, setting.id))));
    }
};
export const EditableSettingsItem = ({ setting, onEdit, onDelete }) => {
    const [isEditing, setIsEditing] = useState(false);
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
        id: setting.id,
    });
    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
    };
    const handleEdit = () => {
        setIsEditing(true);
    };
    const handleClose = () => {
        setIsEditing(false);
    };
    const handleSave = (updatedSetting) => {
        onEdit(updatedSetting);
        setIsEditing(false);
    };
    const handleDelete = () => {
        onDelete(setting.id);
    };
    if (isEditing) {
        return (React.createElement(InlineSettingEditor, { icon: React.createElement(Icon, { component: PencilIcon, height: 12 }), header: React.createElement(SettingContent, { setting: setting }), setting: setting, onSave: handleSave, onClose: handleClose }));
    }
    return (React.createElement(S.SettingItem, { ref: setNodeRef, style: style, ...attributes },
        React.createElement(S.SettingItemHeader, null,
            React.createElement(S.DragHandle, { ...listeners },
                React.createElement(Icon, { component: DragIcon, height: 12 })),
            React.createElement(SettingContent, { setting: setting }),
            React.createElement(S.SettingActions, null,
                React.createElement(Button, { appearance: "destructive-inverted", size: "small", leftIcon: React.createElement(TrashIcon, { height: 12 }), onClick: handleDelete }),
                React.createElement(Button, { appearance: "semi-transparent", size: "small", leftIcon: React.createElement(ArrowShortDownIcon, { height: 12 }), onClick: handleEdit })))));
};
